module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9de7e20462ee8f25c236dca0172dbc52.png";